import { FormControl, FormLabel, TextField } from '@mui/material';
import type { FormikProps } from 'formik';
import type React from 'react';
import useFormControlStyles from '../styles/FormControlStyles';

interface GalleryFormValues {
  name: string;
  mediaGroupId: string;
}

interface GalleryTitleInputProps {
  formik: FormikProps<GalleryFormValues>;
}

const GalleryTitleInput = ({ formik }: GalleryTitleInputProps): React.JSX.Element => {
  const classes = useFormControlStyles();
  return (
    <FormControl className={classes.formElementStyle}>
      <FormLabel className={classes.formControlLabel} color="primary">
        Gallery Title
      </FormLabel>
      <TextField name="name" value={formik.values.name} onChange={formik.handleChange} color="secondary" />
    </FormControl>
  );
};

export default GalleryTitleInput;
